// @flow

import React from "react"
import { injectIntl } from "react-intl"
import { Button, Modal } from "antd"
import styled from "styled-components"

type Props = {
  intl: Object,
  onConfirm: Function,
  onCancel: Function,
  isVisible: boolean
}

const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  min-height: 150px;
  justify-content: space-around;
`

const BodyItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`

const ConfirmCancelOrderModal = (props: Props) => {
  const {
    intl: { formatMessage },
    onConfirm,
    onCancel,
    isVisible = false
  } = props
  return (
    <Modal
      visible={isVisible}
      closable
      destroyOnClose={true}
      title={formatMessage({
        id: "apps.orders.order-search.cancelOrder"
      })}
      onOk={onConfirm}
      onCancel={onCancel}
      footer={null}
    >
      <ModalBody>
        <BodyItem>
          {formatMessage({
            id: "apps.orders.order-search.cancel-order.modal.description"
          })}
        </BodyItem>
        <BodyItem>
          <Button
            key="submit"
            type="danger"
            size="large"
            onClick={onConfirm}
            style={{ minWidth: "189px" }}
          >
            {formatMessage({
              id:
                "apps.orders.order-search.cancel-order.modal.confirmButtonText"
            })}
          </Button>
        </BodyItem>
        <BodyItem>
          <Button
            key="back"
            size="large"
            onClick={onCancel}
            style={{ minWidth: "189px" }}
          >
            {formatMessage({
              id: "apps.orders.order-search.cancel-order.modal.cancelButtonText"
            })}
          </Button>
        </BodyItem>
      </ModalBody>
    </Modal>
  )
}

export default (injectIntl(ConfirmCancelOrderModal): any)
